/**
 * Returns the i18n key for "how this market can be won", aligned with the
 * result worker logic (racing, baseball, football3d) in virtual-core.
 */

const RACING_GROUPS = [501, 502, 503, 504, 505, 506, 507] as const;
const FOOTBALL_BASE_IDS = [5001, 5002, 5003, 5004, 5005, 5006, 5007, 5008, 5009] as const;

export type MarketRow = {
  market_type_id: number | string;
  sport_id?: number | string | null;
  market_type_group_id?: number | string | null;
};

export function getMarketWinDescriptionKey(row: MarketRow): string {
  const sportId = row.sport_id != null ? Number(row.sport_id) : null;
  const groupId = row.market_type_group_id != null ? Number(row.market_type_group_id) : null;
  const marketTypeId = row.market_type_id != null ? Number(row.market_type_id) : null;

  // Racing: win rule by market_type_group_id 501–507
  if (groupId != null && RACING_GROUPS.includes(groupId as (typeof RACING_GROUPS)[number])) {
    return `RTP_MARKET_WIN_DESC_${groupId}`;
  }

  // Baseball (sport 40): win rule by market_type_id 4001–4004
  if (sportId === 40 && marketTypeId != null && marketTypeId >= 4001 && marketTypeId <= 4004) {
    return `RTP_MARKET_WIN_DESC_${marketTypeId}`;
  }

  // Football 3D (50) / Futsal (51): same logic; 51xx maps to 5001–5009
  if (sportId === 50 || sportId === 51) {
    if (marketTypeId == null) return 'RTP_MARKET_WIN_DESC_UNKNOWN';
    const baseId = sportId === 51 ? marketTypeId - 100 : marketTypeId;
    if (FOOTBALL_BASE_IDS.includes(baseId as (typeof FOOTBALL_BASE_IDS)[number])) {
      return `RTP_MARKET_WIN_DESC_${baseId}`;
    }
  }

  return 'RTP_MARKET_WIN_DESC_UNKNOWN';
}
